module.exports = __webpack_public_path__ + "static/media/pizza.5526dbf7.jpg";